import { useEffect, useRef } from 'react';
import { Image } from 'expo-image'; // Use expo-image for better performance
import { View, Animated, StyleSheet } from 'react-native';

interface Props {
    source: any; // Image source, can be a local or remote image
    style?: any; // Optional style for the image
}

export const AnimatedImage = ({ source, style }: Props) => {
    const fadeAnim = useRef(new Animated.Value(0)).current;
    const scaleAnim = useRef(new Animated.Value(0.3)).current;

    useEffect(() => {
        // Start all animations when component mounts
        Animated.parallel([
            // Fade in animation
            Animated.timing(fadeAnim, {
                toValue: 1,
                duration: 800,
                useNativeDriver: true,
            }),
            // Scale animation
            Animated.spring(scaleAnim, {
                toValue: 1,
                friction: 4,
                tension: 100,
                useNativeDriver: true,
            }),
            // Rotation animation
        ]).start();
    }, [fadeAnim, scaleAnim]);

    return (
        <View style={styles.container}>
            <Animated.View
                style={[
                    styles.imageContainer,
                    {
                        opacity: fadeAnim,
                        transform: [
                            { scale: scaleAnim },
                        ],
                    },
                ]}
            >
                <Image source={source} style={[styles.image, style]} />
            </Animated.View>
        </View>
    );
};

const styles = StyleSheet.create({
    container: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
    },
    imageContainer: {
        shadowColor: '#000',
        shadowOffset: {
            width: 0,
            height: 2,
        },
        shadowOpacity: 0.25,
        shadowRadius: 3.84,
        elevation: 5,
    },
    image: {
        width: 200,
        height: 200,
        borderRadius: 10,
    },
});
